import { useEffect } from 'react';

interface PageSEOProps {
  jsonLd: Record<string, unknown>;
}

export default function PageSEO({ jsonLd }: PageSEOProps) {
  useEffect(() => {
    const scriptId = 'page-json-ld';
    const existingScript = document.getElementById(scriptId);
    if (existingScript) {
      existingScript.remove();
    }

    const script = document.createElement('script');
    script.id = scriptId;
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(jsonLd);
    document.head.appendChild(script);

    return () => {
      const currentScript = document.getElementById(scriptId);
      if (currentScript) {
        currentScript.remove();
      }
    };
  }, [jsonLd]);

  return null;
}